import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";

const BidderCTRTable = ({ report, onSortChange }) => {
    const rows = report.map((row, index) => (<Row row={row}  key={index}/>));

    return (
        <Table bordered responsive>
            <Head onSortChange={onSortChange}/>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default BidderCTRTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderCtr/components/Table/index.js